import { SVGProps } from 'react';

const EventsIcon = ({
  height = '24px',
  width = '24px',
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    className='stroke-current'
    viewBox='0 0 24 24'
    {...props}
  >
    <g id='ic-actions-list-add' transform='translate(24) rotate(90)'>
      <g id='ic-actions-list-add-2' data-name='ic-actions-list-add'>
        <rect
          id='Rectangle_445'
          data-name='Rectangle 445'
          width='16'
          height='20'
          rx='2'
          transform='translate(5 2)'
          fill='none'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <line
          id='Line_525'
          data-name='Line 525'
          x2='4'
          transform='translate(3 6.741)'
          fill='none'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <line
          id='Line_526'
          data-name='Line 526'
          x2='4'
          transform='translate(3 17.001)'
          fill='none'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <line
          id='Line_527'
          data-name='Line 527'
          x1='8'
          transform='translate(9.198 11.993)'
          fill='none'
          strokeLinecap='round'
          strokeLinejoin='bevel'
          strokeWidth='2'
        />
        <line
          id='Line_528'
          data-name='Line 528'
          y1='8'
          transform='translate(13.198 7.993)'
          fill='none'
          strokeLinecap='round'
          strokeLinejoin='bevel'
          strokeWidth='2'
        />
      </g>
    </g>
  </svg>
);

export default EventsIcon;
